'use strict';

const ConnectedBaseView = require('../../global/reactHelpers/ConnectedBaseView');
const {connectGalleryModalStoreToView} = require('../helpers/connectViewToStoresHelpers');

// Subviews
const SimpleModal = require('../../components/SimpleModal/SimpleModal-view');
const GalleryModalView = require('./GalleryModalView');

// Actions
const galleryTrackingActions = require('../actions/galleryTrackingActions');
const galleryModalActions = require('./galleryModalActions');
const galleryActions = require('../actions/galleryActions');

const classes = require('../helpers/GalleryConstants').galleryModalClasses;
const {GA_LINK_TARGETS} = galleryTrackingActions;

const Overlay = require('../../components/OverlaySpinner/OverlaySpinnerWrapper.es');

/**
 * Wrapper View For GalleryModal
 *  - initializes SimpleModal
 *  - renders the server-side template in the modal
 *  - initializes the Gallery Subview once the template is rendered in the dom
 *  - shows/hides the modal
 */
const GalleryModalWrapperView = connectGalleryModalStoreToView(ConnectedBaseView).extend({
    className: classes.CONTENT_GALLERY,

    events: {
        [`click .${classes.PHOTO_PROJECT_LINK}`]: '_toProject',
        [`click .${classes.CLOSE_GALLERY_LINK}`]: '_hideModal'
    },

    subViewConfig: {
        modal: {
            construct: SimpleModal,
            singleton: true
        },
        gallery: {
            construct: GalleryModalView,
            singleton: true
        }
    },

    initialize({context}) {
        // Initializing the modal subView
        this.subs.add('modal', {
            content: this,
            closeButton: false,
            // callback triggered after the user presses esc
            manualHideCallback: () => {
                const gallery = this.subs.get('gallery');
                if (gallery) {
                    context.executeAction(galleryModalActions.hideModal);
                }
            },
            classNames: classes.SIMPLE_MODAL_CLASSES
        });
        this.subs.get('modal').render();
        this.overlay = new Overlay();
    },

    /**
     * Calls all necessary methods for resetting the gallery for pages that have more than one gallery modal
     *  - resets the gallery store
     *  - resets the gallery modal store
     *  - removes existing modal view and its subviews
     */
    resetGalleryModal() {
        // Call actions to reset the stores
        this.context.executeAction(galleryActions.resetSetupStore);
        this.context.executeAction(galleryModalActions.resetModal);

        // Remove existing gallery view, so new one renders correctly
        if (typeof this.subs.get('gallery') !== 'undefined') {
            this.subs.get('gallery').remove();
            this.subs.remove('gallery');
        }
    },

    /**
     * Sets the props
     */
    getPropsFromStores(galleryModalStore) {
        const galleryModalOpen = this.subs.get('modal').$el.hasClass('open');

        return {
            isLoading: galleryModalStore.isLoading(),
            hasJustLoaded: galleryModalStore.hasJustLoaded(),
            template: galleryModalStore.getTemplate(),
            shouldShow: !galleryModalStore.isHidden() && !galleryModalOpen,
            shouldClose: galleryModalStore.isHidden() && galleryModalOpen,
            getOriginalUrl: galleryModalStore.getOriginalUrl(),
            originalPageType: galleryModalStore.getOriginalPageType()
        };
    },

    showOverlay() {
        this.overlay.show({
            // need the `parent` every time b/c the DOM
            // is completely rewritten on each ajax request
            parent: this.$el[0],
            // use the global (window) object for the width basis since it's a fixed element
            containerWidth: global.innerWidth,
            containerHeight: global.innerHeight
        });
    },

    /**
     * Render method called after the view receives new props
     *  - Opens/closes the modal
     *  - Renders the template in the modal (the first open only)
     */
    render() {
        const props = this.props;
        const galleryModal = this.subs.get('modal');

        // If the modal content is loading then render loading content
        // and show the modal
        if (props.isLoading) {
            galleryModal.$el.addClass(classes.STATE_NOT_LOADED);
            this.showOverlay();
            galleryModal.show();

        // If the modal is loaded but has never been opened before then render
        // the template and show the modal
        } else if (props.hasJustLoaded) {
            this.$el.html(props.template);
            this.subs.add('gallery', {context: this.context, isModal: true, pageType: props.originalPageType});

            galleryModal.$el.removeClass(classes.STATE_NOT_LOADED);
            galleryModal.show();

        // Show the modal
        } else if (props.shouldShow) {
            galleryModal.show();

        // Hide the modal
        } else if (props.shouldClose) {
            galleryModal.hide();
        }
    },

    /**
     * Event Handler - executes action to to hide the modal
     *  (invoked either when the close button is clicked or when the link to the projects is clicked)
     */
    _hideModal(e) {
        e.preventDefault();
        this.getContext().executeAction(galleryModalActions.hideModal);
        this.getContext().executeAction(galleryTrackingActions.trackLinkClick, {target: GA_LINK_TARGETS.CLOSE});
    },

    _toProject(event) {
        const projectUrl = this.$(`.${classes.PHOTO_PROJECT_LINK}`).attr('href');

        if (projectUrl === this.props.getOriginalUrl) {
            this._hideModal(event);
        }
    }
});

module.exports = GalleryModalWrapperView;



// WEBPACK FOOTER //
// ./assets/js/gallery/modal/GalleryModalWrapperView.es.js